/** A real die face in native SVG: cream body, ink pips. Never decorative: every
 * rendered die is a bid face, a revealed roll or the viewer's own private hand. */
const PIPS: Record<number, number[]> = {
  1: [4],
  2: [2, 6],
  3: [2, 4, 6],
  4: [0, 2, 6, 8],
  5: [0, 2, 4, 6, 8],
  6: [0, 2, 3, 5, 6, 8],
};
export function Die({
  value,
  match = false,
}: {
  value: number;
  match?: boolean;
}) {
  return (
    <span
      className={`die${match ? " is-match" : ""}`}
      role="img"
      aria-label={`${value}${match ? ", matches" : ""}`}
    >
      <svg aria-hidden="true" viewBox="0 0 30 30" width="100%" height="100%">
        {(PIPS[value] ?? []).map((n) => (
          <circle
            key={n}
            cx={7.5 + (n % 3) * 7.5}
            cy={7.5 + Math.floor(n / 3) * 7.5}
            r={value === 1 ? 3.6 : 2.7}
            fill="currentColor"
          />
        ))}
      </svg>
    </span>
  );
}
